var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.isLoading)?_c('Loader'):_c('div',{staticClass:"app-container"},[_c('More'),_c('div',{staticClass:"inner-container"},[_c('Home')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }